import { useState } from 'react';
import api from '../config/api';

const useGuestImageSave = () => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);

  const saveGuestImage = async ({ event_id, image_urls }) => {
    setSaving(true);
    setError(null);
    setProgress(0);

    try {
      const response = await api.post('/event-guest-images/upload', {
        event_id,
        image_urls,
      });

      // Simulate small progress completion
      setProgress(100);
      setSaving(false);

      return response.data;
    } catch (err) {
      setSaving(false);
      setError(err.response?.data?.message || 'Save failed');
      return null;
    }
  };

  return {
    saveGuestImage,
    saving,
    error,
    progress,
  };
};

export default useGuestImageSave;
